import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-200/50'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-lg md:text-xl text-background-50"></i>
            </div>
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-50 tracking-wide">
              91<span className="text-primary-400">制片厂</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-all duration-300 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-500/20 text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-lg transition-all duration-300 whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-all duration-300 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-500/20 text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-medium text-foreground-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              加入会员
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-50"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200/50">
          <div className="px-4 py-4 flex flex-col gap-1">
            <Link
              to="/"
              className="px-4 py-3 text-sm rounded-lg text-foreground-50 hover:bg-background-200/50 transition-colors"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 text-sm rounded-lg text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50 transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 text-sm rounded-lg text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50 transition-colors"
            >
              关于我们
            </Link>
            <Link
              to="/about"
              className="mt-2 px-5 py-2.5 text-sm font-medium text-center text-foreground-50 bg-primary-500 rounded-full whitespace-nowrap"
            >
              加入会员
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}